import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import { getBusinessPartner } from '../../api/businessPartner';
import { useDropdownOptions } from '../UnifiedLoad/queryHooks/useDropdownOptions';
import BPFooter from './BPFooter';
import BPHeader from './BPHeader';
import BPSection from './BPSection';
import { BusinessPartnerContext } from './BusinessPartnerCard';
import { SECTIONS } from './utils';

const convertDropdownFormat = (options = []) => {
  return options.reduce((accumulator, currentValue) => {
    return {
      ...accumulator,
      [currentValue.id]: currentValue.data,
    };
  }, {});
};

const BPDefaults = ({ id }) => {
  const { localBPData, isEditing, handleOnChange } = useContext(BusinessPartnerContext);
  const [lastUpdated, setLastUpdated] = useState('');

  const directionSelected = localBPData.Defaults?.find((d) => d.subtitle === 'Movement Type')?.value;
  const localLastUpdated = localBPData.Defaults?.find((d) => d.subtitle === 'Last Modified')?.value;

  const { staticDropdowns, dropdownsByDirection } = useDropdownOptions({ movementType: directionSelected });
  const { routes, portProcesses, shippingStatuses } = staticDropdowns.data || {};
  const { despatchCountries, destinationCountries, exitPorts, entryPorts } = dropdownsByDirection.data || {};

  const dropdowns = {
    'Movement Type': convertDropdownFormat(routes),
    'Country of Despatch': convertDropdownFormat(despatchCountries),
    'Country of Destination': convertDropdownFormat(destinationCountries),
    'Port Model': convertDropdownFormat(portProcesses),
    'Exit Port': convertDropdownFormat(exitPorts),
    'Entry Port': convertDropdownFormat(entryPorts),
    'Shipping Status': convertDropdownFormat(shippingStatuses),
  };

  const changeHandlerWrapper = async (subtitle, value, title) => {
    handleOnChange(subtitle, value, title);
    if (subtitle === 'Movement Type') {
      //reset these fields when movement type changes
      [
        'Country of Despatch',
        'Country of Destination',
        'Exit Port',
        'Entry Port',
        'Port Model',
        'Shipping Status',
      ].forEach((subtitleToReset) => {
        handleOnChange(subtitleToReset, '', title);
      });
    }
  };

  const fetchLastUpdated = async () => {
    const newData = await getBusinessPartner('Defaults', id);
    const newLastUpdated = newData?.find((d) => d.subtitle === 'Last Modified')?.value;
    setLastUpdated(newLastUpdated);
  };

  return (
    <>
      <section className="bp-defaults">
        <BPHeader />
        <BPSection
          sections={SECTIONS['bp-defaults']}
          isEditing={isEditing}
          localBPData={localBPData}
          dropdownValues={dropdowns}
          handleOnChange={changeHandlerWrapper}
        />
      </section>
      <p>{(lastUpdated || localLastUpdated) && `last updated by ${lastUpdated || localLastUpdated}`}</p>
      <BPFooter afterSave={fetchLastUpdated} />
    </>
  );
};

BPDefaults.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BPDefaults;
